import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/views/Home'
import Research from '@/views/Research'
import ProfessorLi from '@/views/ProfessorLi'
import Publications from '@/views/Publications'
import Members from '@/views/Members'
import Links from '@/views/Links'
import JoinUs from '@/views/JoinUs'
import PDFShow from '@/views/PDFShow'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/research',
      name: 'Research',
      component: Research
    },
    {
      path: '/prof_li',
      name: 'ProfessorLi',
      component: ProfessorLi
    },
    {
      path: '/members',
      name: 'Members',
      component: Members
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../views/News.vue')
    },
    {
      path: '/news/:id',
      name: 'NewsDetail',
      component: () => import('../views/news/NewsDetail.vue')
    },
    {
      path: '/news/detail',
      name: 'NewsDetail',
      component: () => import('../views/news/NewsDetail.vue')
    },
    {
      path: '/photos',
      name: 'photos',
      component: () => import('../views/Photos.vue')
    },
    {
      path: '/photos/detail',
      name: 'PhotosDetail',
      component: () => import('../views/photos/PhotosDetail.vue')
    },
    {
      path: '/publications',
      name: 'Publications',
      component: Publications
    },
    {
      path: '/links',
      name: 'Links',
      component: Links
    },
    {
      path: '/join-us',
      name: 'JoinUs',
      component: JoinUs
    },
    {
      path: '/pdf/:id',
      name: 'PDFShow',
      component: PDFShow
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('../views/TestPage.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js